// useClientSettings.js
import { useEffect, useMemo, useState } from 'react';

const LS_KEY = 'gfClientSettingsV1';

// sensible starter set incl. flowers
const DEFAULTS = {
  crops: {
    // FOOD
    'Sweet Genovese Basil': { category: 'food', seedGrams: 6, needsTransplant: true },
    'Thai Basil':           { category: 'food', seedGrams: 9, needsTransplant: true },
    'Salvo Basil':          { category: 'food', seedGrams: 9, needsTransplant: true },
    'Coriander Cruiser':    { category: 'food', seedGrams: 8, needsTransplant: false },
    'Dill Delight':         { category: 'food', seedGrams: 12, needsTransplant: false },
    'Parsley Italian Giant':{ category: 'food', seedGrams: 8, needsTransplant: false },
    'Chives Medium Leaf':   { category: 'food', seedGrams: 7, needsTransplant: false },
    'Chives Thick Leaf':    { category: 'food', seedGrams: 6, needsTransplant: false },
    'Sorrel Red Veined':    { category: 'food', seedGrams: 14, needsTransplant: false },
    'Mizuna':               { category: 'food', seedGrams: 3, needsTransplant: false },
    'Lettuce Mesclun Mix':  { category: 'food', seedGrams: 6, needsTransplant: false },
    'Leaf Beet Spinach':    { category: 'food', seedGrams: 8, needsTransplant: false },
    'American Cress':       { category: 'food', seedGrams: 6, needsTransplant: false },
    'Egyptian Mint':        { category: 'food', seedGrams: 2, needsTransplant: false },
    'English Thyme':        { category: 'food', seedGrams: 5, needsTransplant: false },
    'Lemon Grass':          { category: 'food', seedGrams: 4, needsTransplant: false },
    'Lemon Balm':           { category: 'food', seedGrams: 4, needsTransplant: false },
    'Buckwheat':            { category: 'food', seedGrams: 8, needsTransplant: false },
    'Spinach Perpetual':    { category: 'food', seedGrams: 6, needsTransplant: false },
    'French Salad Mix':     { category: 'food', seedGrams: 6, needsTransplant: false },
    // FLOWERS
    'Sunflowers Mixed':     { category:'flower', seedInputMode:'count',  seedsPerTray:2, needsTransplant:false },
    'Snapdragon Potomac':   { category:'flower', seedInputMode:'count',  seedsPerTray:40, needsTransplant:true },
  },
  fallbackSeedGrams: 8
};

export default function useClientSettings() {
const [settings, setSettings] = useState(() => {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return DEFAULTS;

    const parsed = JSON.parse(raw);

    return {
      ...DEFAULTS,
      ...parsed,
      crops: {
        ...DEFAULTS.crops,
        ...parsed.crops,
      }
    };
  } catch {
    return DEFAULTS;
  }
});

  useEffect(() => {
    try { localStorage.setItem(LS_KEY, JSON.stringify(settings)); } catch {}
  }, [settings]);

  const cropList = useMemo(() => Object.keys(settings.crops), [settings]);
  const gramsFor = (crop) => {
    const g = settings.crops?.[crop]?.seedGrams;
    return (typeof g === 'number' && !Number.isNaN(g)) ? g : settings.fallbackSeedGrams;
  };
  const categoryFor = (crop) => settings.crops?.[crop]?.category || 'food';

// add inside useClientSettings()
const seedModeFor = (crop) => settings.crops?.[crop]?.seedInputMode || 'weight';
const seedsPerTrayFor = (crop) => settings.crops?.[crop]?.seedsPerTray ?? 0;

return { settings, setSettings, cropList, gramsFor, categoryFor, seedModeFor, seedsPerTrayFor };

}
